import { __assign, __awaiter, __extends, __generator, __spreadArray } from "tslib";
import { toolbox } from '../../externals/bss-package-toolbox/js/toolbox.js';
import logger from '@main/externals/bss-package-logger/js/logger';
import EntityBuilder from '../bss-entity-builder/js/bss-entity-builder.js';
import FontFaceObserver from 'fontfaceobserver';
import simulatorErrorTemplate from '../../view/components/bss-error-page-component/template/errorPage.hbs';
import simulatorRevertTemplate from '../../view/components/bss-entity-revert-info-component/template/revertInfo.hbs';
import { BaseControllerToolbox } from './base-controller-toolbox';
var PUBLISHER_NAME = 'bss-connector';
var PUBLISHER_STEP_NAVIGATION = 'bss-step-navigation';
var ENTITY_OVERLAY_SELECTOR = 'bss-hide-entity-overlay-';
var RULE_INTERACT_CONTAINER = '.rule-interact-container';
var ONLINE_APPROVAL_BUTTON_CLASS = '.bss-button--online-approval button';
var PRODUCT_ID = '{productId}';
var ENTITY_ID = '{entityId}';
var SHOW_ENTITY_EVENT = 'bss-show-entity-overlay-';
var simulatorTemplates = {
    errorTemplate: simulatorErrorTemplate,
    revertTemplate: simulatorRevertTemplate,
};
/**
 * @desc BSSControllerToolbox
 */
var BSSControllerToolbox = /** @class */ (function (_super) {
    __extends(BSSControllerToolbox, _super);
    function BSSControllerToolbox(environment, resolutionsConfig, version, components, descriptionConfig, flowProps, setFlowConfigurationCallback, insideWidgetQuoteId, setInsideWidgetQuoteIdCallback, isWidgetInWidget, isCompareFinance, theme, origin, isLocaleAphelia, initConfiguration, standalone) {
        if (environment === void 0) { environment = null; }
        if (resolutionsConfig === void 0) { resolutionsConfig = null; }
        if (version === void 0) { version = 'prod'; }
        if (components === void 0) { components = null; }
        if (descriptionConfig === void 0) { descriptionConfig = null; }
        if (flowProps === void 0) { flowProps = null; }
        if (setFlowConfigurationCallback === void 0) { setFlowConfigurationCallback = null; }
        if (insideWidgetQuoteId === void 0) { insideWidgetQuoteId = null; }
        if (setInsideWidgetQuoteIdCallback === void 0) { setInsideWidgetQuoteIdCallback = null; }
        if (isWidgetInWidget === void 0) { isWidgetInWidget = null; }
        if (isCompareFinance === void 0) { isCompareFinance = false; }
        if (theme === void 0) { theme = null; }
        if (origin === void 0) { origin = null; }
        if (isLocaleAphelia === void 0) { isLocaleAphelia = null; }
        if (initConfiguration === void 0) { initConfiguration = null; }
        if (standalone === void 0) { standalone = null; }
        var _this = _super.call(this, environment, resolutionsConfig, version, components, descriptionConfig, flowProps, setFlowConfigurationCallback, insideWidgetQuoteId, setInsideWidgetQuoteIdCallback, isWidgetInWidget, isCompareFinance, theme, origin, isLocaleAphelia, initConfiguration, standalone) || this;
        /**
         * @desc add listener on the entity element for the finished tagging event,
         * this is required for BC markets when the CTA button is clicked.
         * after clicking CTA, we open the customer's car configurator - and before we open it, we need to make sure that tagging has ended
         * @listens {dxp-tagging-finished}
         * @public
         */
        _this._addFinishedTaggingListener = function () {
            logger.info('ControllerToolbox => function: _addFinishedTaggingListener');
            _this._currentEntity._entityContainer[0].addEventListener('dxp-tagging-finished', _this._onFinishedTagging);
        };
        /**
         * @desc set variable on true for finished tagging
         * @public
         */
        _this._onFinishedTagging = function () {
            logger.info('ControllerToolbox => function: _onFinishedTagging');
            _this._isTaggingFinished = true;
        };
        /**
         * @desc make feature specific simulator request to server,
         *  to return 'desired' data from server to be for custom save event on generic close button on Italy market
         * @return promise, on resolve it returns calculated offer
         * @private
         */
        _this._makeDesiredDataRequest = function (publishername, params) {
            var error = params.error, success = params.success;
            var url = params === null || params === void 0 ? void 0 : params.url;
            var requestParams = params === null || params === void 0 ? void 0 : params.params;
            _this._showOverlay();
            if (!params) {
                var requestData = _this._getOfferDataForLeadGenerationCall();
                url = requestData.url;
                requestParams = requestData.params;
            }
            if (!url) {
                console.log('Missing lead generation url');
                _this._removeLoading();
                return;
            }
            var def = new toolbox.$.Deferred();
            var callback = _this._makeDataRequestCallback.bind(_this, def, error, success);
            var entityInstanceId = _this.getCurrentEntityInstanceId();
            _this._BSSBackendConnector.makeDataRequest(url, requestParams, callback, entityInstanceId);
            return def.promise();
        };
        /**
         * @desc feature specific functionality:
         * retrieve value of parameter provided by Italy integrator to call for lead generation form
         * @return promise, on resolve it returns calculated offer
         * @private
         */
        _this._getLeadGenerationData = function () {
            _this._showOverlay();
            var requestData = _this._getOfferDataForLeadGenerationCall();
            var url = requestData.url, params = requestData.params;
            if (!url) {
                console.log('Missing lead generation url');
                _this._removeLoading();
                return;
            }
            var def = new toolbox.$.Deferred();
            var callback = _this._getLeadGenerationDataCallback.bind(_this, url, def);
            var entityInstanceId = _this.getCurrentEntityInstanceId();
            _this._BSSBackendConnector.makeDataRequest(url, params, callback, entityInstanceId);
            return def.promise();
        };
        /**
         * Show 'minor' error popup
         * @param publisherName {string}
         * @param errorObj {{}} errorObject - error object
         * @private
         */
        _this._showMinorErrorPopup = function (publisherName, errorObj) {
            if (errorObj === void 0) { errorObj = {}; }
            logger.info('ControllerToolbox => function: _showMinorErrorPopup | Params: ', publisherName, errorObj);
            var revertStateTitle = errorObj.errorTitle, revertStateMsg = errorObj.errorMsg;
            _this._showErrorPopup({
                revertStateTitle: revertStateTitle,
                revertStateMsg: revertStateMsg,
            }, errorObj);
            _this._hideOverlay();
        };
        return _this;
    }
    BSSControllerToolbox.prototype.setFlowConfigurationWithoutParams = function () {
        this._eventManager.subscribe('bss-close-entity-' + this._flowId, this._closeUpdateFinance.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe('bss-destroy-connector-event', this._clearModalPopupStyle.bind(this));
        this._eventManager.subscribe('bss-destroy-connector-event', this._clearModalPopupStyle.bind(this));
        this._setFlowConfigurationCallback();
        this._addModalPopupStyle();
        if (!this.entityBuilder) {
            this.entityBuilder = new EntityBuilder(this._eventManager, this._formatter, this._resolutions, toolbox, this._components, null, true);
        }
        this.getCfTextsConfiguration();
        var config = this.parseRequest();
        this.entityBuilder
            .createEntity(this._entitySelector, null, config, null, null, this._isWidgetInWidget, this._entitySelector, this._theme, this._isLocaleAphelia, true)
            .then(this._onEntityCreated.bind(this));
    };
    /**
     * @desc simple setter for flow configuration
     * @param {Object} error - error object
     * @param {Object} data - flow configuration object
     * @emits {bss-flow-config-ready}
     * @listens {bss-create-flow-$FLOW-ID-entity-$ENTITY-ORDER}
     * @listens {bss-click-print-pdf-entity-$ENTITY-ORDER}
     * @public
     */
    BSSControllerToolbox.prototype.setFlowConfiguration = function (error, data) {
        var _this = this;
        logger.info('ControllerToolbox => function: setFlowConfiguration | Params: ', error, data);
        if (!this._validateFlowId(data === null || data === void 0 ? void 0 : data.flowId))
            return;
        this._flowId = data.flowId;
        this._setFlowConfigurationCallback();
        if (this._checkRequestErrorAndData(error, data, 'setFlowConfiguration')) {
            // if there is no error and all data nodes exist
            this._flowConfiguration = this._setProtocol(data);
            this._initialEntityId = this._flowConfiguration.initialEntityId;
            this._privateUrl = "".concat(this._environmentUrl, "/binaries/images/");
            // support old config - single entity
            if (typeof this._flowConfiguration.entities === 'undefined') {
                this._currentEntityId = this._initialEntityId;
                var urls = this._flowConfiguration.commonURLs;
                this._flowEntities[this._initialEntityId] = {
                    dataUrlBase: urls.entitySimulatorURL,
                    resultUrlBase: urls.entityDataURL,
                    textsUrlBase: urls.entityTranslationsURL,
                    variantsUrlBase: urls.entityVariantListUrl,
                    carDetailsUrlBase: urls.entityCarInfoDetailsUrl,
                    getCustomizeUrl: urls.entityURLtoGetCustomizeURL,
                    getPdfUrl: urls.entityURLtoGetPDF,
                    legalTextForModelUrl: urls.entityCarFinancialDetailsURL,
                    legalTextForVariantUrl: urls.entityVariantFinancialDetailsURL,
                    financialDetailsURL: urls.entityFinancialDetailsURL,
                    calculationRawDataUrl: urls.entityCalculationRawDataURL,
                    entitySelector: '#entity',
                    entityContainer: toolbox.$('#entity'),
                    configuration: {},
                    defaultOffer: {},
                    isDefaultOfferOutOfDate: true,
                    customOffer: {},
                    customOfferPrevious: {},
                    type: 'simulator',
                    order: 1,
                    currentProdId: null,
                };
                this._flowEntities[this._initialEntityId].entityContainer.addClass('bss-entity-container');
            }
            // in multi-entity flow, add config for each entity
            else {
                var self_1 = this;
                toolbox._.forEach(this._flowConfiguration.entities, function (entityConfig, entityId) {
                    var urls = entityConfig.commonURLs;
                    self_1._flowEntities[entityId] = {
                        dataUrlBase: urls.entitySimulatorURL,
                        resultUrlBase: urls.entityDataURL,
                        textsUrlBase: urls.entityTranslationsURL,
                        entityGetDocumentURL: urls.entityGetDocumentURL,
                        entitySendEmailURL: urls.entitySendEmailURL,
                        variantsUrlBase: urls.entityVariantListUrl,
                        carDetailsUrlBase: urls.entityCarInfoDetailsUrl,
                        getCustomizeUrl: urls.entityURLtoGetCustomizeURL,
                        getPdfUrl: urls.entityURLtoGetPDF,
                        legalTextForModelUrl: urls.entityCarFinancialDetailsURL,
                        legalTextForVariantUrl: urls.entityVariantFinancialDetailsURL,
                        financialDetailsURL: urls.entityFinancialDetailsURL,
                        calculationRawDataUrl: urls.entityCalculationRawDataURL,
                        dependencies: entityConfig.dependencies,
                        entitySelector: entityConfig.container,
                        entityContainer: toolbox.$(entityConfig.container),
                        configuration: {},
                        defaultOffer: {},
                        isDefaultOfferOutOfDate: true,
                        customOffer: {},
                        customOfferPrevious: {},
                        type: entityConfig.type,
                        order: entityConfig.order,
                        currentProdId: null,
                        initData: entityConfig.initData || null,
                    };
                    var flowEntity = self_1._flowEntities[entityId];
                    if (flowEntity.type === self_1.elementType) {
                        flowEntity.entityContainer.addClass('bss-entity-container');
                    }
                    // subscribe to public event for entity creation
                    self_1._eventManager.subscribe('bss-create-flow-' +
                        self_1._flowId +
                        '-entity-' +
                        entityConfig.order, self_1.setEntity.bind(self_1, entityConfig.order), 'ControllerToolbox');
                    // subscribe to public event for print pdf
                    self_1._eventManager.subscribe('bss-click-print-pdf-entity-' + entityConfig.order, self_1._printPdf.bind(self_1), 'ControllerToolbox');
                });
            }
            this._eventManager.subscribe('bss-list-box-open-list', this._openListBC.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-list-box-accordion-content-shown-bcDetails', this._closeDetailsBC.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-list-box-send-request-for-Details-on-budget-calculator', this._openDetailsBC.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-list-box-accordion-content-shown-bcFinancialDetails', this._closeFinancialDetailsBC.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-compare-list-send-request-for-FinancialDetails-on-product-comparison', this._openFinancialDetailsPopup.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-list-box-send-request-for-FinancialDetails-on-budget-calculator', this._openFinancialDetailsPopup.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-list-box-open-cta', this._onClickCTA.bind(this), 'ControllerToolbox');
            this._eventManager.publish('bss-flow-config-ready', PUBLISHER_NAME, {}, true);
            // subscribe to public event for update finance after click close button
            if (this.elementType !== 'compareFinance')
                this._eventManager.subscribe('bss-close-entity-' + this._flowId, this._closeUpdateFinance.bind(this), 'ControllerToolbox');
            this._eventManager.subscribe('bss-open-external-link-' + this._flowId, function (name, data) { return _this._openExternalLink(data.url); }, 'ControllerToolbox');
            this._eventManager.subscribe('bss-open-offer-' + this._flowId, function (name, data) {
                _this._showOverlay();
                if (data && data.tyCode) {
                    var link = data.brand === 'toyota'
                        ? 'https://formulieren.toyota.nl/offerte-aanvraag.html'
                        : 'https://formulieren.lexus.nl/offerte-aanvraag.html';
                    _this._openExternalLink("".concat(link, "?amount=").concat(data.amount, "&duration=").concat(data.duration, "&deposit=").concat(data.downpayment, "&finalterm=").concat(data.finalTerm, "&productCode=").concat(data.productCode, "&cid=").concat(data.tyCode)),
                        'ControllerToolbox';
                }
            });
            this._eventManager.subscribe('bss-open-advice-' + this._flowId, function (name, data) {
                _this._showOverlay();
                if (data && data.tyCode) {
                    var link = data.brand === 'toyota'
                        ? 'https://formulieren.toyota.nl/contact-finance-specific.html'
                        : 'https://formulieren.lexus.nl/contact-finance-specific.html';
                    _this._openExternalLink("".concat(link, "?amount=").concat(data.amount, "&duration=").concat(data.duration, "&deposit=").concat(data.downpayment, "&finalterm=").concat(data.finalTerm, "&productCode=").concat(data.productCode, "&cid=").concat(data.tyCode)),
                        'ControllerToolbox';
                }
            });
            this._eventManager.subscribe('bss-open-mail-' + this._flowId, function (name, data) {
                _this._showOverlay();
                if (data && data.tyCode) {
                    var link = data.brand === 'toyota'
                        ? 'https://formulieren.toyota.nl/mail-financiering-overzicht.html'
                        : 'https://formulieren.lexus.nl/mail-financiering-overzicht.html';
                    _this._openExternalLink("".concat(link, "?amount=").concat(data.amount, "&duration=").concat(data.duration, "&deposit=").concat(data.downpayment, "&finalterm=").concat(data.finalTerm, "&productCode=").concat(data.productCode, "&cid=").concat(data.tyCode)),
                        'ControllerToolbox';
                }
            });
            this._eventManager.subscribe('bss-destroy-connector-event', this._clearModalPopupStyle.bind(this));
            this._eventManager.subscribe('bss-destroy-connector-event', this._clearModalPopupStyle.bind(this));
            this._addModalPopupStyle();
        }
    };
    /**
     * NBSS-10113
     * Add additional class to entity container to differentiate styles when scroll appears,
     * eg for revert state popup message
     * @private
     */
    BSSControllerToolbox.prototype._addScrollClass = function () {
        logger.info('ControllerToolbox => function: _addScrollClass');
        var modalBodyEL = this._entityContainer.parents('.tor-modal-body')[0];
        if (modalBodyEL && modalBodyEL.clientHeight < modalBodyEL.scrollHeight) {
            this._entityContainer.addClass('bss-scroll');
        }
    };
    BSSControllerToolbox.prototype._openExternalLink = function (link) {
        this._eventManager.publish('bss_cta_triggered', PUBLISHER_NAME, { url: link, type: 'custom' }, true);
    };
    /**
     * @desc open variants list method - BC
     * @public
     */
    BSSControllerToolbox.prototype._openListBC = function (name, dataId) {
        if (dataId === void 0) { dataId = null; }
        logger.info('ControllerToolbox => function: _openListBC | Params: ', name, dataId);
        var currentProductId = this._flowEntities[this._currentEntityId].currentProdId;
        var currentProductParams = this._flowEntities[this._currentEntityId].configuration.resultData[currentProductId];
        var params = {};
        params[currentProductId.toString()] = currentProductParams;
        if (dataId && dataId.modelId) {
            this._modelId = dataId.modelId;
        }
        else {
            this._modelId = null;
        }
        this._onUserChange(name, params);
    };
    /**
     * @desc handles CTA actions on BC
     * @public
     */
    BSSControllerToolbox.prototype._onClickCTA = function (name, data) {
        var _this = this;
        if (data === void 0) { data = null; }
        logger.info('ControllerToolbox => function: _onClickCTA | Params: ', name, data);
        if (data.type === 'getUrl' && (data === null || data === void 0 ? void 0 : data.tagging)) {
            this._addFinishedTaggingListener();
        }
        var currentProductId = this._flowEntities[this._currentEntityId].currentProdId;
        var params = {};
        var entityInstanceId = this.getCurrentEntityInstanceId();
        var type = null;
        var quoteId = null;
        var activeWindowOpen = null;
        params[currentProductId.toString()] = data;
        if (data.type) {
            type = data.type;
            quoteId = params[currentProductId].quoteId;
            activeWindowOpen = this._prepareUrl(data, currentProductId, activeWindowOpen);
            this._publishCloseEvent(quoteId);
        }
        this._deleteTypeParameter(params, currentProductId);
        this._deleteQuoteIdParameter(params, currentProductId, type);
        this._publishShowEntityEvent(entityInstanceId);
        try {
            this._calculateOffer(false, currentProductId, params[currentProductId]).then(function (currentOffer) {
                if (type === 'getPdf') {
                    activeWindowOpen.location.href = currentOffer.url;
                    _this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, currentOffer);
                }
                else if (type === 'getUrl') {
                    if (typeof data.tagging !== 'undefined' && data.tagging) {
                        _this._isTaggingFinished = false;
                        window.open(currentOffer.url, '_self');
                    }
                    else if (typeof data.tagging === 'undefined' || !data.tagging) {
                        _this._onFinishedTagging();
                        window.open(currentOffer.url, '_self');
                    }
                    else {
                        _this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, {});
                    }
                }
            });
        }
        catch (e) {
            this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, {});
        }
        this._isTaggingFinished = false;
    };
    BSSControllerToolbox.prototype._prepareUrl = function (data, currentProductId, activeWindowOpen) {
        if (data.type === 'getPdf') {
            this._url = this._flowEntities[this._currentEntityId].getPdfUrl.replace(PRODUCT_ID, currentProductId);
            activeWindowOpen = window.open('', '_self');
        }
        else if (data.type === 'getUrl') {
            this._url = this._flowEntities[this._currentEntityId].getCustomizeUrl.replace(PRODUCT_ID, currentProductId);
        }
        return activeWindowOpen;
    };
    BSSControllerToolbox.prototype._publishShowEntityEvent = function (entityInstanceId) {
        this._eventManager.publish(SHOW_ENTITY_EVENT + entityInstanceId, PUBLISHER_NAME, this.getCustomOffer());
    };
    BSSControllerToolbox.prototype._deleteQuoteIdParameter = function (params, currentProductId, type) {
        if (toolbox._.has(params[currentProductId], 'quoteId') &&
            type !== 'getPdf' &&
            type !== 'getUrl') {
            delete params[currentProductId].quoteId;
        }
    };
    BSSControllerToolbox.prototype._deleteTypeParameter = function (params, currentProductId) {
        if (toolbox._.has(params[currentProductId], 'type')) {
            delete params[currentProductId].type;
        }
    };
    BSSControllerToolbox.prototype._publishCloseEvent = function (quoteId) {
        this._eventManager.publish('bss-close-entity-' + this._flowId, PUBLISHER_NAME, {
            finance: quoteId,
        }, true);
    };
    /**
     * @desc open car details method - BC
     * @public
     */
    BSSControllerToolbox.prototype._openDetailsBC = function (name, dataId) {
        logger.info('ControllerToolbox => function: _openDetailsBC | Params: ', name, dataId);
        var currentProductId = this._flowEntities[this._currentEntityId].currentProdId;
        var currentProductParams = this._flowEntities[this._currentEntityId].configuration.resultData[currentProductId];
        var params = {};
        params[currentProductId.toString()] = currentProductParams;
        this._carId = dataId.carId;
        this._onUserChange(name, params);
    };
    /**
     * @desc open car details method - Budget Calculator and Product Comparison
     * @public
     */
    BSSControllerToolbox.prototype._openFinancialDetailsPopup = function (name, data) {
        logger.info('ControllerToolbox => function: _openFinancialDetailsPopup | Params: ', name, data);
        var currentProductId = this._flowEntities[this._currentEntityId].currentProdId;
        var currentProductParams = this._flowEntities[this._currentEntityId].configuration.resultData[currentProductId];
        var params = {};
        params[currentProductId.toString()] = currentProductParams;
        this._modelId = data.modelId;
        if (data.carId) {
            this._detailsForCar = true;
            this._carId = data.carId;
        }
        else {
            this._detailsForCar = false;
        }
        if (data.quoteId &&
            this._configurationParams &&
            this._configurationParams.country === 'de') {
            this._url = this._flowEntities[this._currentEntityId].financialDetailsURL;
            params[currentProductId.toString()] = this._configurationParams;
            params[currentProductId.toString()].quoteId = data.quoteId;
            this._isPopupPC = true;
        }
        else if (data.disclaimer) {
            this._eventManager.publish('bss-popup-showOnEvent-popupTermConditions', PUBLISHER_NAME, { disclaimer: data.disclaimer }, false);
        }
        else if (this._detailsForCar) {
            this._url = this._flowEntities[this._currentEntityId].legalTextForVariantUrl
                .replace(ENTITY_ID, this._currentEntityId)
                .replace('{offerId}', currentProductId.toString())
                .replace('{modelId}', this._modelId)
                .replace('{carId}', this._carId);
        }
        else {
            this._url = this._flowEntities[this._currentEntityId].legalTextForModelUrl
                .replace(ENTITY_ID, this._currentEntityId)
                .replace('{offerId}', currentProductId.toString())
                .replace('{modelId}', this._modelId);
        }
        var type = this._flowEntities[this._currentEntityId].type;
        var requestParams;
        if (type === 'productComparison') {
            this._flowEntities[this._currentEntityId].resultUrlBase = "".concat(this._environmentUrl, "/dispatcher/ccGetLegalText");
            requestParams = this._initOptions;
        }
        this._onUserChange(name, params, requestParams);
    };
    /**
     * @desc close financial details method - BC
     * @public
     */
    BSSControllerToolbox.prototype._closeFinancialDetailsBC = function () {
        logger.info('ControllerToolbox => function: _closeFinancialDetailsBC');
        if (this._detailsForCar) {
            this._carId = null;
        }
        else {
            this._modelId = null;
        }
    };
    /**
     * @desc close car details method - BC
     * @public
     */
    BSSControllerToolbox.prototype._closeDetailsBC = function () {
        logger.info('ControllerToolbox => function: _closeDetailsBC');
        this._carId = null;
    };
    /**
     * @desc print pdf method
     * @public
     */
    BSSControllerToolbox.prototype._printPdf = function () {
        logger.info('ControllerToolbox => function: _printPdf');
        var currentProductId = this._flowEntities[this._currentEntityId].currentProdId;
        var url = this._flowEntities[this._currentEntityId].resultUrlBase
            .replace(ENTITY_ID, this._currentEntityId)
            .replace('{offerId}', currentProductId) + '/printPdf';
        var params = this._flowEntities[this._currentEntityId].configuration.resultData[currentProductId];
        this._onPrintRequest(url, JSON.stringify(params));
    };
    /**
     * @desc on print request method
     * @param {String} url
     * @param {Object} data
     * @private
     */
    BSSControllerToolbox.prototype._onPrintRequest = function (url, data) {
        logger.info('ControllerToolbox => function: _printPdf | Params: ', url, data);
        var form;
        var input;
        form = document.createElement('form');
        form.action = url;
        form.method = 'POST';
        form.target = '_blank';
        input = document.createElement('textarea');
        input.name = 'printPdfData';
        input.value = data;
        form.appendChild(input);
        form.style.display = 'none';
        document.body.appendChild(form);
        form.trigger('submit');
        document.body.removeChild(form);
    };
    /**
     * @desc prepare for creating/showing entity with given order
     * @param {Number} entityOrder
     * @public
     */
    BSSControllerToolbox.prototype.setEntity = function (entityOrder) {
        var _a, _b, _c;
        logger.info('ControllerToolbox => function: setEntity | Params: ', entityOrder);
        this._disabledOnlineApprovalButton();
        // support for old config - single entity flow
        if (entityOrder === null) {
            this._createFlowEntity(this._initialEntityId);
            return;
        }
        // get entity id and type based on its order
        var entityId = false;
        var entityType;
        toolbox._.forEach(this._flowEntities, function (entityData, entityIndex) {
            if (entityData.order === entityOrder) {
                entityId = entityIndex;
                entityType = entityData.type;
            }
        });
        // if there is no such entity, show error msg
        if (!entityId) {
            var errObj = {
                errorMsg: 'ControllerToolbox setEntity error: there is no entity with order ' +
                    entityOrder,
            };
            this._errorHandler(null, errObj);
            return;
        }
        this._publishEventIfEntityTypeIsOnlineApproval(entityType, entityId);
        // else create entity with given order
        this._entityToBeShown = entityId;
        // check if given entity already exists
        if (this._checkEntityExistence(entityId)) {
            if (entityType === 'onlineApproval') {
                this._tempOAOffer = this._flowEntities[entityId].defaultOffer;
                // if existing OA is no created with the same product ID as the request is for,
                // destroy OA and create it again - there is different UI Desc for OA for different products
                if (!Object.hasOwn(this._currentEntity, '_entityPrevProductId') ||
                    !this._currentEntity._entityPrevProductId) {
                    this._currentEntity._entityPrevProductId =
                        this._currentEntity._entityActiveProductId;
                }
                else if (this._currentEntity._entityActiveProductId !==
                    this._currentEntity._entityPrevProductId) {
                    this.destroyOA(entityId);
                    this._setIsDefaultOfferOutOfDate(true, entityId);
                    this._flowEntities[entityId].defaultOffer = {};
                    this._currentEntity._entityPrevProductId =
                        this._currentEntity._entityActiveProductId;
                    this._tempOAOffer = {};
                    // else just send request for resultData
                }
                else {
                    var self_2 = this;
                    var currentProdId = this._flowEntities[entityId].currentProdId;
                    this._cleanOAChecksum(currentProdId);
                    this._setActiveEntity(entityId);
                    this._sendRequestForResultDataOnOnlineApproval(currentProdId, self_2, entityId);
                    this._showEntity(entityId);
                    this._tempOAOffer = {};
                    this._publishTaggingEvent(entityId, 'simulatorHasFullyLoaded');
                    (_b = (_a = toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[entityId]) === null || _b === void 0 ? void 0 : _b.init(__assign(__assign({}, toolbox.resultDataFlat[this._flowEntities[entityId].currentProdId]), { integrationMode: ((_c = this._options) === null || _c === void 0 ? void 0 : _c.integrationMode) || null }));
                    return;
                }
            }
            // else show this entity
            else {
                this._showEntity(entityId);
                var entityInstanceId = this.getCurrentEntityInstanceId();
                this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, {});
                this._currentEntity._entityPrevProductId =
                    this._currentEntity._entityActiveProductId;
                this._setTempOfferForOnlineApproval();
                return;
            }
        }
        // if entity was not created or was destroyed, create it
        this._createFlowEntity(entityId);
    };
    BSSControllerToolbox.prototype._disabledOnlineApprovalButton = function () {
        if (toolbox.$(ONLINE_APPROVAL_BUTTON_CLASS)) {
            toolbox.$(ONLINE_APPROVAL_BUTTON_CLASS).attr('disabled', true);
        }
    };
    BSSControllerToolbox.prototype._setTempOfferForOnlineApproval = function () {
        if (this._onlineApprovalId) {
            this._tempOAOffer =
                this._flowEntities[this._onlineApprovalId].defaultOffer;
        }
    };
    BSSControllerToolbox.prototype._sendRequestForResultDataOnOnlineApproval = function (currentProdId, self, entityId) {
        if (Object.hasOwn(this._tempOAOffer[currentProdId], 'step')) {
            this._calculateOffer(false, currentProdId, this._tempOAOffer[currentProdId]).then(function (data) {
                self._setDefaultOffer(entityId, data);
                self._setCustomOffer(entityId, data);
            });
            this._eventManager.publish('bss-create-flow-' + this._flowId + '-entity-1', PUBLISHER_NAME, {}, true);
        }
        else {
            this._calculateOffer(false, currentProdId).then(function (data) {
                self._setDefaultOffer(entityId, data);
                self._setCustomOffer(entityId, data);
            });
        }
    };
    BSSControllerToolbox.prototype._publishEventIfEntityTypeIsOnlineApproval = function (entityType, entityId) {
        if (entityType === 'onlineApproval') {
            this._onlineApprovalId = entityId;
            var entityInstanceId = this.getCurrentEntityInstanceId();
            this._eventManager.publish(SHOW_ENTITY_EVENT + entityInstanceId, PUBLISHER_NAME, {});
        }
    };
    /**
     * NBSS-5357 When Online approval is opened next time the old checksum should be removed from current entity resultData
     * (Online approval default offer)
     * @private
     */
    BSSControllerToolbox.prototype._cleanOAChecksum = function (productId) {
        this._tempOAOffer[productId].checksum = null;
    };
    /**
     * @desc creates entity entity regarding to config and UIDescription (when entity builder js is loaded)
     * @param {String} entityId
     * @listens {bss-update-finance-$ENTITY-INSTANCE-ID}
     * @listens {bss-entity-critical-error-$CURRENT-ENTITY-ID}
     * @private
     */
    BSSControllerToolbox.prototype._createEntity = function (entityId) {
        logger.info('ControllerToolbox => function: _createEntity | Params: ', entityId);
        this._setActiveEntity(entityId);
        // get default offer for entity
        if (toolbox.$.isEmptyObject(this.getDefaultOffer()) ||
            this._getIsDefaultOfferOutOfDate(entityId)) {
            this._calculateOfferWrapper(this._createEntity.bind(this, entityId));
            return;
        }
        var entityInstanceId = toolbox.$.now();
        this._eventManager.subscribe('bss-update-finance-' + entityInstanceId, this._onUpdateFinanceEvent.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe('bss-entity-critical-error-' + entityInstanceId, this._errorHandler.bind(this), 'ControllerToolbox');
        // add flow params to toolbox resultDataFlat for possible future needs e.g. in tagging (UK OA)
        toolbox.resultDataFlat[this._flowEntities[entityId].currentProdId].flowParams = this._flowParams;
        var elementType = this._getElementType(entityId);
        // check if entity builder exists - if not, create it
        if (!this.entityBuilder) {
            this.entityBuilder = new EntityBuilder(this._eventManager, this._formatter, this._resolutions, toolbox, this._components, elementType);
        }
        this.entityBuilder
            .createEntity(this._flowEntities[entityId].entitySelector, entityId, this._flowEntities[entityId].configuration, entityInstanceId, elementType, this._isWidgetInWidget, this._entitySelector, this._theme, this._isLocaleAphelia)
            .then(this._onEntityCreated.bind(this));
    };
    BSSControllerToolbox.prototype._cloneComponents = function (obj) {
        var dropdownTargets = [
            'incomeFrequency',
            'incomeType',
            'expenseType',
            'expenseFrequency',
        ];
        var radioTargets = ['incomeNetOrGross'];
        var textInputTargets = ['incomeAmount', 'expenseAmount'];
        var cloneComponents = function (components, targets, copies) {
            if (copies === void 0) { copies = 3; }
            var newComponents = __spreadArray([], components, true);
            targets.forEach(function (targetName) {
                var baseComp = components.find(function (c) { return c.name === targetName; });
                if (baseComp) {
                    for (var i = 2; i <= copies; i++) {
                        var cloned = JSON.parse(JSON.stringify(baseComp));
                        cloned.name = "".concat(baseComp.name).concat(i);
                        newComponents.push(cloned);
                    }
                }
            });
            return newComponents;
        };
        obj.dropdownComponents = cloneComponents(obj.dropdownComponents, dropdownTargets, 3);
        obj.radioButtonComponents = cloneComponents(obj.radioButtonComponents, radioTargets, 3);
        obj.textInputComponents = cloneComponents(obj.textInputComponents, textInputTargets, 3);
        return obj;
    };
    /**
     * @desc gets and sets locally calculated default offer and initial state of custom offer
     * @param {Function} [callback = null]
     * @private
     */
    BSSControllerToolbox.prototype._calculateOfferWrapper = function (callback) {
        if (callback === void 0) { callback = null; }
        logger.info('ControllerToolbox => function: _calculateOfferWrapper | Params: ', callback);
        var entityId = this._currentEntityId;
        var self = this;
        this._checkEntityId(entityId);
        this.checkFlowConfiguration();
        this._calculateOffer(true, entityId).then(function (data) {
            if (self.elementType === 'onlineApproval') {
                for (var key in data.resultData) {
                    if (data.resultData.hasOwnProperty(key)) {
                        var item = data.resultData[key];
                        item.components = self._cloneComponents(item.components);
                    }
                }
            }
            var activeEntity = self._flowEntities[entityId];
            if (activeEntity.currentProdId === null &&
                Object.hasOwn(data, 'resultData') &&
                Object.keys(data.resultData).length) {
                activeEntity.currentProdId = Object.keys(data.resultData)[0];
                toolbox.currentProductId = activeEntity.currentProdId;
            }
            self._setDefaultOffer(entityId, data);
            self._setCustomOffer(entityId, data);
            self._setEntityConfiguration(entityId, data);
            if (callback !== null) {
                try {
                    callback(entityId);
                }
                catch (err) {
                    var errObj = {
                        entityInstanceId: self.getCurrentEntityInstanceId(),
                        errorMsg: '',
                    };
                    if (typeof callback !== 'function') {
                        errObj.errorMsg =
                            'Controller calculateOffer error: The calculateOffer callback is not a function - ' +
                                err;
                        self._errorHandler(null, errObj);
                    }
                    else {
                        errObj.errorMsg =
                            'Controller calculateOffer error: During calculateOffer callback unhandled exception caught - ' +
                                err;
                        self._errorHandler(null, errObj);
                    }
                }
            }
        });
    };
    /**
     * @desc retrieve value of parameter provided by integrator, user or calculated
     * @param {String} publishername - publisher name
     * @param {Object} data - data provided with event, data from component updateted after user change
     * @emits {bss-show-entity-overlay-$ENTITY-INSTANCE-ID}
     * @emits {bss-data-received-$ENTITY-INSTANCE-ID}
     * @emits {bss-hide-entity-overlay-$ENTITY-INSTANCE-ID}
     * @emits {bss-send-request-$ENTITY-INSTANCE-ID}
     * @emits {bss-received-request-$ENTITY-INSTANCE-ID}
     * @return promise, on resolve it returns calculated offer
     * @private
     */
    BSSControllerToolbox.prototype._onUserChange = function (publishername, data, requestParams) {
        var _this = this;
        logger.info('ControllerToolbox => function: _onUserChange | Params: ', publishername, data);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        var isSubmited = false;
        this._eventManager.publish('bss-send-request-' + entityInstanceId, PUBLISHER_NAME, {});
        var depValues = this._getEntityDependenciesValues(this._currentEntityId);
        var currentData = data[this._currentEntity._entityActiveProductId];
        this._clearDependentVariables(currentData);
        var _loop_1 = function (item) {
            /* eslint-disable */
            depValues = this_1._updateEntityDependenciesValues(depValues, data[item]);
            this_1._updateComponentsVals(data[item], depValues);
            try {
                this_1._saveCustomOfferPrevious(this_1._currentEntityId);
                this_1._eventManager.publish(SHOW_ENTITY_EVENT + entityInstanceId, PUBLISHER_NAME, this_1.getCustomOffer());
                this_1._deleteQuoteIdIfForductIsNotProductComparison(data, item);
                isSubmited = !!data[item].isSubmited;
                this_1._calculateOffer(false, item, data[item], requestParams).then(function (currentOffer) {
                    if (publishername === 'bss-compare-list') {
                        _this._eventManager.publish('bss-popup-showOnEvent-popupTermConditions', PUBLISHER_NAME, currentOffer, false);
                    }
                    _this._setCustomOffer(_this._currentEntityId, currentOffer);
                    currentOffer.updateTimestamp = new Date().getTime();
                    currentOffer.offerId = item;
                    _this._setFinanceObject(currentOffer[item]);
                    _this._eventManager.publish('bss-data-received-' + entityInstanceId, PUBLISHER_NAME, currentOffer);
                    _this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, currentOffer);
                    if (isSubmited) {
                        _this._eventManager.publish('bss-click-on-submit-' + entityInstanceId, PUBLISHER_NAME, currentOffer);
                        _this._eventManager.publish('bss-flow-' +
                            _this._flowId +
                            '-entity-' +
                            entityInstanceId +
                            '-submit', PUBLISHER_NAME, currentOffer[currentOffer.offerId], true);
                    }
                    _this._eventManager.publish('bss-received-request-' + entityInstanceId, PUBLISHER_NAME, {});
                });
            }
            catch (err) {
                var updateObj = this_1.getCustomOffer();
                updateObj.updateTimestamp = new Date().getTime();
                this_1._eventManager.publish('bss-data-received-' + entityInstanceId, PUBLISHER_NAME, updateObj);
                this_1._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, this_1.getCustomOffer());
                this_1._eventManager.publish('bss-received-request-' + entityInstanceId, PUBLISHER_NAME, {});
            }
        };
        var this_1 = this;
        for (var item in data) {
            _loop_1(item);
        }
    };
    BSSControllerToolbox.prototype._clearDependentVariables = function (currentData) {
        if (this._options &&
            this._options.clearDependentVariables &&
            this._currentValueChange) {
            for (var item in this._options.clearDependentVariables) {
                if (this._options.clearDependentVariables[item].fields.indexOf(this._currentValueChange) !== -1) {
                    currentData[item] = this._options.clearDependentVariables[item].value;
                }
            }
        }
    };
    BSSControllerToolbox.prototype._deleteQuoteIdIfForductIsNotProductComparison = function (data, item) {
        if (toolbox._.has(data[item], 'quoteId') &&
            data[item].elementType !== 'productComparison') {
            delete data[item].quoteId;
        }
    };
    BSSControllerToolbox.prototype.getCfTextsConfiguration = function () {
        if (this.isCompareFinance && !this._compareFinanceTexts) {
            this._compareFinanceTexts = [
                {
                    data: [
                        [
                            {
                                productName: 'PCP',
                                productType: 'gb_pcp_toyota',
                                title: 'Personal contract purchase (PCP)',
                            },
                            {
                                productName: 'PCH',
                                productType: 'gb_pch_toyota',
                                title: 'Personal contract hire (PCH)',
                            },
                            {
                                productName: 'HP',
                                productType: 'gb_hp_toyota',
                                title: 'Hire Purchase (HP)',
                            },
                        ],
                        [
                            {
                                description: 'Personal Contract Purchase (PCP) is a flexible ownership plan designed to get you into the car that best suits your needs and budget. PCP comes with the following end of agreement options - upgrading to a new car, keeping the car or returning the car. Find out more about PCP. \n\nFinance is provided by Toyota Financial Services (UK) PLC. Click here to read full terms and conditions.',
                                title: 'What is it?',
                            },
                            {
                                description: 'Personal Contract Hire (PCH) is provided by KINTO One and is a convenient motoring option if you don’t want to own the car at the end of the Agreement. Budgeting is made easy with fixed rentals, plus you can include an optional maintenance package to avoid any unexpected costs. Find out more about PCH. \n\nContract Hire is provided by KINTO UK Limited. Click here to read full hire terms and conditions.',
                                title: 'What is it?',
                            },
                            {
                                description: 'Hire Purchase (HP) is a convenient way of financing when you want to own the car at the end of your finance agreement. Your payments are fixed for the length (term) of your finance agreement. Finance is provided by Toyota Financial Services (UK) PLC.',
                                title: 'What is it?',
                            },
                        ],
                        [
                            {
                                description: null,
                                list: [
                                    'Fixed monthly payments',
                                    'Choose a term that suits you from 24 to 42 months',
                                    'Decide on your annual mileage up front',
                                    'Put down a deposit of up to 35% of the car price to suit your budget',
                                    'Enjoy flexible end of agreement options and lower monthly payments because a proportion of the amount is deferred to the end of your finance agreement. This amount is called the Guaranteed Future Value (GFV) or Optional Final Payment.',
                                    '3 options at the end of your finance agreement: keep, upgrade or return the car.',
                                ],
                                title: 'Key Features',
                            },
                            {
                                description: null,
                                list: [
                                    'Fixed monthly rentals',
                                    'Choose a term that suits you from 24 to 48 months ',
                                    'Decide on your mileage upfront',
                                    'Make an initial rental to the value of anywhere between 1 to 9 months rentals',
                                    'No large final payment at the end of your finance agreement.',
                                    'Return the car at the end of your finance agreement',
                                    'Optional fixed maintenance costs',
                                ],
                                title: 'Key Features',
                            },
                            {
                                description: null,
                                list: [
                                    'Fixed monthly payments',
                                    'Choose a term that suits you from 12 to 60 months',
                                    'No need to decide on annual mileage as there are no mileage restrictions',
                                    'Put down a deposit of up to 95% of the car price to suit your budget',
                                    'No large final payment at the end of your finance agreement',
                                    'Own the car at the end of your finance agreement, once all payments have been made',
                                ],
                                title: 'Key Features',
                            },
                        ],
                        [
                            {
                                description: null,
                                list: [
                                    'If you want to keep the car at the end of your finance agreement, you will need to pay the Guaranteed Future Value or Final Payment. Once this is paid, ownership will be transferred to you.',
                                    'If you exceed the agreed mileage and choose to return the car, an excess mileage charge will be payable at the end of your finance agreement.',
                                    'If you decide to return the car at the end of your finance agreement and it is in poor condition which is outside fair wear and tear guidelines, you will be required to pay for the damage. Our representative will assess the car in line with the current BVRLA Fair Wear and Tear Guide. Any items outside of this acceptable range will be charged.',
                                    'If you fail to make the payments under your finance agreement, we will assist you in your circumstances to achieve a sustainable outcome, but you may have to return the car or it can be repossessed, legal proceedings may be commenced agaianst you to recover sums that you may owe and your credit rating may be adversely affected.',
                                    'The car is likely to depreciate in value during the life of your finance agreement',
                                ],
                                title: 'Key Risks',
                            },
                            {
                                description: null,
                                list: [
                                    'At the end of your finance agreement, the car must be returned in the same condition it was initially hired out subject to fair wear and tear, and agreed mileage. ',
                                    'If you exceed the agreed mileage and choose to return the car, an excess mileage charge will be payable at the end of your finance agreement.',
                                    'If the car is in poor condition which is outside fair wear and tear guidelines at the end of your finance agreement, you will be required to pay for the damage. Our representative will assess the vehile in line with the current BVRLA Fair Wear and Tear Guide. Any items outside of this acceptable range will be charged',
                                    'If you fail to make the payments under your finance agreement, we will assist you in your circumstances to achieve a sustainable outcome, but you may have to return the car or it can be repossessed, legal proceedings may be commenced agaianst you to recover sums that you may owe and your credit rating may be adversely affected.',
                                    'Your finance agreement is design to run for the full term. If you wish to terminate the agreement early, you will be required to pay future rentals charges.',
                                ],
                                title: 'Key Risks',
                            },
                            {
                                description: null,
                                list: [
                                    'Ownership of the car will be transferred to you once all payments under your finance agreement have been made.',
                                    'If you fail to make the payments under your finance agreement, we will assist you in your circumstances to achieve a sustainable outcome, but you may have to return the car or it can be repossessed, legal proceedings may be commenced against you to recover sums that you may owe and your credit rating may be adversely affected.',
                                    'The car is likely to depreciate in value during the life of your finance agreement.',
                                ],
                                title: 'Key Risks',
                            },
                        ],
                    ],
                    variant: 'summary',
                },
                {
                    data: [
                        [
                            {
                                productName: 'PCP',
                                productType: 'gb_pcp_toyota',
                                title: 'Personal Contract Purchase (PCP)',
                            },
                            {
                                productName: 'PCH',
                                productType: 'gb_pch_toyota',
                                title: 'Personal Contract Hire (PCH)',
                            },
                            {
                                productName: 'HP',
                                productType: 'gb_hp_toyota',
                                title: 'Hire Purchase (HP)',
                            },
                        ],
                        [
                            {
                                description: '0 to 35%',
                                title: 'How much deposit can I put down?',
                            },
                            {
                                description: 'From 1-9 months rentals',
                                title: 'How much deposit can I put down?',
                            },
                            {
                                description: '0 to 95%',
                                title: 'How much deposit can I put down?',
                            },
                        ],
                        [
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Are there any mileage restrictions?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Are there any mileage restrictions?',
                            },
                            {
                                description: 'No',
                                icon: '&amp;#xe915',
                                title: 'Are there any mileage restrictions?',
                            },
                        ],
                        [
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Are monthly payments fixed?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Are monthly rentals fixed?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Are monthly payments fixed?',
                            },
                        ],
                        [
                            {
                                description: 'Optional',
                                icon: '',
                                title: 'Is a Guaranteed Future Value (GFV) or Optional Final Payment required when the agreement ends?',
                            },
                            {
                                description: 'No',
                                icon: '',
                                title: 'Is a Guaranteed Future Value (GFV) or Optional Final Payment required when the agreement ends?',
                            },
                            {
                                description: 'Once you’ve made your final monthly payment, the car is yours to keep.',
                                icon: '',
                                title: 'Is a Guaranteed Future Value (GFV) or Optional Final Payment required when the agreement ends?',
                            },
                        ],
                        [
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Is VAT payable on my monthly payments?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Is VAT payable on my monthly payments?',
                            },
                            {
                                description: 'No',
                                icon: '&amp;#xe915',
                                title: 'Is VAT payable on my monthly payments?',
                            },
                        ],
                        [
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Is fully comprehensive insurance required?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Is fully comprehensive insurance required?',
                            },
                            {
                                description: 'Yes',
                                icon: '&amp;#xe94a',
                                title: 'Is fully comprehensive insurance required?',
                            },
                        ],
                        [
                            {
                                description: 'Yes, you can keep, upgrade, or return your car.*',
                                icon: '&amp;#xe94a',
                                title: 'Will I have the option to own the car after the agreement?',
                            },
                            {
                                description: 'No, you will not own the car and must return it.^',
                                icon: '&amp;#10005',
                                title: 'Will I have the option to own the car after the agreement?',
                            },
                            {
                                description: 'Yes. Ownership passes once all the monthly payments have been paid, or if you settle all applicable payments earlier.',
                                icon: '&amp;#xe94a',
                                title: 'Will I have the option to own the car after the agreement?',
                            },
                        ],
                        [
                            {
                                description: 'From 24 to 42 months.†',
                                icon: '',
                                title: 'What is the length of agreement?',
                            },
                            {
                                description: 'From 24 to 48 months.±',
                                icon: '',
                                title: 'What is the length of agreement?',
                            },
                            {
                                description: 'Choose a term from 24 to 60 months*',
                                icon: '',
                                title: 'What is the length of agreement?',
                            },
                        ],
                        [
                            {
                                description: 'The Guaranteed Future Value (GFV) is the final payment which is secured by the value of the car. If the car is worth less than the GFV, you can choose to return it to the finance company with nothing further to pay, subject to terms and conditions. If the car is worth more than the GFV you get the equity.',
                                icon: '&amp;#xe94a',
                                title: 'Do I take the risk of depreciation?',
                            },
                            {
                                description: 'Because you do not own the car, the depreciation risk is taken by KINTO UK Limited.',
                                icon: '&amp;#xe915',
                                title: 'Do I take the risk of depreciation?',
                            },
                            {
                                description: 'Once all payments under your finance agreement are made, ownership automatically passes to you, so any depreciation risk is yours.',
                                icon: '&amp;#xe915',
                                title: 'Do I take the risk of depreciation?',
                            },
                        ],
                        [
                            {
                                description: 'You can settle the agreement at any time. For regulated agreements, an early settlement amount is calculated in accordance with the Consumer Credit (Early Settlement) Regulations 2004.',
                                icon: '&amp;#xe94a',
                                title: 'Can I change the car before the end of the agreement?',
                            },
                            {
                                description: 'No, your finance agreement is designed to run for the full term.',
                                icon: '&amp;#10005;',
                                title: 'Can I change the car before the end of the agreement?',
                            },
                            {
                                description: 'If you decide to part exchange, you will need to settle your finance agreement, you can do this at any time. For regulated finance agreements, an early settlement amount is calculated in accordance with the Consumer Credit (Early Settlement) Regulations 2004.',
                                icon: '&amp;#xe94a;',
                                title: 'Can I change the car before the end of the agreement?',
                            },
                        ],
                        [
                            {
                                description: "It is a condition of the agreement that the car must be maintained in line with the manufacturer's guidelines.",
                                icon: '&amp;#10003',
                                title: 'Do I have to maintain the car?',
                            },
                            {
                                description: "It is a condition of the agreement that the car must be maintained in line with the manufacturer's guidelines. You can build the cost of maintenance into the monthly rental.",
                                icon: '&amp;#xe94a',
                                title: 'Do I have to maintain the car?',
                            },
                            {
                                description: 'Your finance agreement will state that the car must be maintained in line with the manufacturer’s guidelines.',
                                icon: '&amp;#xe94a',
                                title: 'Do I have to maintain the car?',
                            },
                        ],
                    ],
                    disclaimers: [
                        [
                            {
                                description: '*Max terms vary according to vehicle model',
                            },
                            {
                                description: '*Max terms vary according to vehicle model',
                            },
                            {
                                description: '*Max terms vary according to car model.',
                            },
                        ],
                        [
                            {
                                description: '**Keep - pay the GFV and own your car;\n Return - Hand the car back;\n Upgrade - Part exchange the car for new car',
                            },
                            {
                                description: '',
                            },
                            {
                                description: '',
                            },
                        ],
                    ],
                    variant: 'compare',
                },
            ];
        }
    };
    /**
     * @desc retrieve value of parameter provided by integrator, user or calculated
     * @param {Boolean} checkInnerNodes - if true check weather inner nodes exists (false on initialization for calculateOffer function)
     * @param {String} offerId - type of offer
     * @param {Object} tempCustomOffer
     * @return promise, on resolve it returns calculated offer
     * @private
     */
    BSSControllerToolbox.prototype._calculateOffer = function (checkInnerNodes, offerId, tempCustomOffer, requestParams) {
        return __awaiter(this, void 0, void 0, function () {
            var def, entityInstanceId, requestData, url, params, url_1, error_1, callback;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.info('ControllerToolbox => function: _calculateOffer | Params: ', checkInnerNodes, offerId, tempCustomOffer);
                        //delete error list from data object
                        if (tempCustomOffer && Object.hasOwn(tempCustomOffer, 'errors')) {
                            delete tempCustomOffer.errors;
                        }
                        def = new toolbox.$.Deferred();
                        entityInstanceId = this.getCurrentEntityInstanceId();
                        requestData = this._getCalculationOfferData(offerId, tempCustomOffer, requestParams);
                        url = requestData.url, params = requestData.params;
                        if (params && (params === null || params === void 0 ? void 0 : params.elementType) === 'productComparison') {
                            this._configurationParams = requestData.params;
                        }
                        if (!(this.isCompareFinance && !this._compareFinanceTexts)) return [3 /*break*/, 4];
                        url_1 = "".concat(this._environmentUrl, "/dispatcher/compareFinance/simulator/").concat(this._initialEntityId, "/texts");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this._BSSBackendConnector.getCompareFinanceTexts(url_1, function (err, data) {
                                    if (!err) {
                                        reject(err);
                                    }
                                    _this._compareFinanceTexts = data.texts;
                                    resolve(data);
                                }, entityInstanceId);
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        callback = (params === null || params === void 0 ? void 0 : params.validateState)
                            ? this._validateOfferCallback.bind(this, checkInnerNodes, offerId, tempCustomOffer, url, def)
                            : this._calculateOfferCallback.bind(this, checkInnerNodes, offerId, tempCustomOffer, url, def);
                        this._BSSBackendConnector.getCalculatedOffer(url, params, callback, entityInstanceId);
                        return [2 /*return*/, def.promise()];
                }
            });
        });
    };
    /**
     * Hide element overlay
     * @private
     */
    BSSControllerToolbox.prototype._showOverlay = function () {
        var entityInstanceId = this.getCurrentEntityInstanceId();
        this._eventManager.publish("bss-show-entity-overlay-".concat(entityInstanceId), PUBLISHER_NAME);
    };
    /**
     * Hide element overlay
     * @private
     */
    BSSControllerToolbox.prototype._hideOverlay = function () {
        var entityInstanceId = this.getCurrentEntityInstanceId();
        this._eventManager.publish("bss-hide-entity-overlay-".concat(entityInstanceId), PUBLISHER_NAME);
    };
    /**
     * Callback on BE response after financial data change
     * @param error {{}}
     * @param res {{}}
     * @param checkInnerNodes {boolean}
     * @param offerId {string}
     * @param tempCustomOffer {{}}
     * @param url {string}
     * @param def {Promise}
     */
    BSSControllerToolbox.prototype._validateOfferCallback = function (checkInnerNodes, offerId, tempCustomOffer, url, def, error, res) {
        logger.info('ControllerToolbox => function: _validateOfferCallback | Params: ', error, res);
        var data = this.parseRequest(res);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        var isValid = false;
        this._noErrorPopup = true;
        if (this._checkRequestErrorAndData(error, data, 'getCalculatedOffer', checkInnerNodes, offerId, false)) {
            isValid = true;
            // Wait until user will confirm validated state
            // eg by clicking on 'Confirm' button
            this._eventManager.subscribe("bss-validated-state-confirm-".concat(entityInstanceId), 
            // Apply validated offer (standard offer calculation logic)
            this._calculateOfferCallback.bind(this, checkInnerNodes, offerId, tempCustomOffer, url, def, error, res), 'ControllerToolboxTabClick');
        }
        else {
            // if error occurred
            def.resolve({});
        }
        var validatedFinanceOfferEventName = "bss-params-validated-".concat(entityInstanceId);
        // Tell component that validation is completed with success
        this._eventManager.publish(validatedFinanceOfferEventName, PUBLISHER_NAME, {
            isValid: isValid,
        });
        this._removeLoading();
        this._noErrorPopup = false;
    };
    /**
     * Remove loading overlay
     * @private
     */
    BSSControllerToolbox.prototype._removeLoading = function () {
        logger.info('ControllerToolbox => function: _removeLoading');
        var $currentEntityContainer = this._flowEntities[this._currentEntityId].entityContainer;
        $currentEntityContainer
            .find('.bss-entity-overlay')
            .removeClass('is-active');
    };
    /**
     * Get calculation offer data to be sent to BE on financial data change
     * @param offerId {string}
     * @param tempCustomOffer {{}}
     * @returns {{params: {}, url: string}}
     * @private
     */
    BSSControllerToolbox.prototype._getCalculationOfferData = function (offerId, tempCustomOffer, requestParams) {
        logger.info('ControllerToolbox => function: _getCalculationOfferData');
        var depValues = this._getEntityDependenciesValues(this._currentEntityId);
        var currentProdId = this._getCurrentProdId();
        var dataUrlBase = this._flowEntities[this._currentEntityId].dataUrlBase;
        var requestData;
        if (toolbox.$.isEmptyObject(this.getDefaultOffer())) {
            requestData = {
                url: dataUrlBase
                    .replace(ENTITY_ID, this._currentEntityId)
                    .replace('{offerId}', currentProdId),
                params: toolbox.$.extend({ language: this._flowProps.lang }, this._flowParams, depValues),
            };
        }
        else {
            var url = void 0;
            var params = toolbox.$.extend({ language: this._flowProps.lang }, tempCustomOffer, depValues);
            if (this._url) {
                url = this._url;
                params = tempCustomOffer;
                this._url = null;
            }
            else {
                if (this._modelId) {
                    url = this._setUrlWhenModelIdExist(offerId);
                }
                else {
                    if (requestParams !== undefined)
                        params = requestParams;
                    url = this._flowEntities[this._currentEntityId].resultUrlBase
                        .replace(ENTITY_ID, this._currentEntityId)
                        .replace('{offerId}', offerId);
                }
                if (typeof tempCustomOffer !== 'undefined' &&
                    tempCustomOffer.isSubmited === 'true') {
                    url = "".concat(url, "/scoring");
                    delete tempCustomOffer.isSubmited;
                    this._setTextOnScoring(tempCustomOffer);
                    params = toolbox.$.extend({ language: this._flowProps.lang }, this._flowParams, tempCustomOffer);
                    this._checkParamsValueInOfferData(params);
                }
            }
            requestData = {
                url: url,
                params: params,
            };
        }
        return requestData;
    };
    /**
     * Check if param value is in offer data,
     * if not, overwrite with data from components
     * @param params {{}}
     * @private
     */
    BSSControllerToolbox.prototype._checkParamsValueInOfferData = function (params) {
        if (params.country === 'gb') {
            var title = params.title;
            if (!title.trim())
                params.title = params.components.dropdownComponents.find(function (el) { return el.name === 'title'; }).value;
            var paramsToCheckTextInputComponents = [
                'firstName',
                'lastName',
                'phoneNumber',
                'email',
                'emailConfirmation',
            ];
            var textInputComponents_1 = params.components.textInputComponents;
            paramsToCheckTextInputComponents.forEach(function (param) {
                if (!params[param].trim()) {
                    params[param] = textInputComponents_1.find(function (el) { return el.name === param; }).value;
                }
            });
        }
    };
    BSSControllerToolbox.prototype._setTextOnScoring = function (tempCustomOffer) {
        try {
            // On Scoring to backend send texts to generate templates (email, pdf)
            tempCustomOffer.texts =
                this._flowEntities[this._currentEntityId].configuration.layout.texts.general;
        }
        catch (e) {
            logger.error('ControllerToolbox => function: _calculateOffer error when try bind values');
        }
    };
    BSSControllerToolbox.prototype._setUrlWhenModelIdExist = function (offerId) {
        if (this._carId) {
            return this._flowEntities[this._currentEntityId].carDetailsUrlBase
                .replace(ENTITY_ID, this._currentEntityId)
                .replace(PRODUCT_ID, offerId)
                .replace('{modelId}', this._modelId)
                .replace('{carId}', this._carId);
        }
        else {
            return this._flowEntities[this._currentEntityId].variantsUrlBase
                .replace(ENTITY_ID, this._currentEntityId)
                .replace('{offerId}', offerId)
                .replace('{modelId}', this._modelId);
        }
    };
    BSSControllerToolbox.prototype._setUrlForCalculationOfferData = function (url, params, tempCustomOffer, offerId) {
        if (this._url) {
            url = this._url;
            params = tempCustomOffer;
            this._url = null;
        }
        else {
            if (this._modelId) {
                if (this._carId) {
                    url = this._flowEntities[this._currentEntityId].carDetailsUrlBase
                        .replace(ENTITY_ID, this._currentEntityId)
                        .replace(PRODUCT_ID, offerId)
                        .replace('{modelId}', this._modelId)
                        .replace('{carId}', this._carId);
                }
                else {
                    url = this._flowEntities[this._currentEntityId].variantsUrlBase
                        .replace(ENTITY_ID, this._currentEntityId)
                        .replace('{offerId}', offerId)
                        .replace('{modelId}', this._modelId);
                }
            }
            else {
                url = this._flowEntities[this._currentEntityId].resultUrlBase
                    .replace(ENTITY_ID, this._currentEntityId)
                    .replace('{offerId}', offerId);
            }
            if (typeof tempCustomOffer !== 'undefined' &&
                tempCustomOffer.isSubmited === 'true') {
                url = "".concat(url, "/scoring");
                delete tempCustomOffer.isSubmited;
                try {
                    // On Scoring to backend send texts to generate templates (email, pdf)
                    tempCustomOffer.texts =
                        this._flowEntities[this._currentEntityId].configuration.layout.texts.general;
                }
                catch (e) {
                    logger.error('ControllerToolbox => function: _calculateOffer error when try bind values');
                }
                params = toolbox.$.extend({ language: this._flowProps.lang }, this._flowParams, tempCustomOffer);
            }
        }
        return { url: url, params: params };
    };
    /**
     * Get offer data for to be sent to BE on 'desired' data call,
     * used to call for Lead Generation on Italy market
     * @returns {{params: {}, url: string}}
     * @private
     */
    BSSControllerToolbox.prototype._getOfferDataForLeadGenerationCall = function () {
        logger.info('ControllerToolbox => function: _getOfferDataForLeadGenerationCall');
        var depValues = this._getEntityDependenciesValues(this._currentEntityId);
        var currentEntity = this._flowEntities[this._currentEntityId];
        var currentProdId = currentEntity.currentProdId, _a = currentEntity.calculationRawDataUrl, calculationRawDataUrl = _a === void 0 ? '' : _a;
        // Product id is gotten by BE from calculateQuoteId
        var url = calculationRawDataUrl
            .replace(ENTITY_ID, this._currentEntityId)
            .replace('{offerId}', currentProdId);
        var calculateQuoteId = currentEntity.customOffer.resultData[currentProdId].calculateQuoteId;
        return {
            url: url,
            params: toolbox.$.extend({
                language: this._flowProps.lang,
                calculateQuoteId: calculateQuoteId,
            }, this._flowParams, depValues),
        };
    };
    /**
     * Callback on BE response after call for financial data needed for Lead Generation call (desired data) on Italy
     * @param url {string}
     * @param def {Promise}
     * @param error {{}}
     * @param res {{}}
     */
    BSSControllerToolbox.prototype._getLeadGenerationDataCallback = function (url, def, error, res) {
        var desiredData = this.parseRequest(res);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        if (error || !desiredData) {
            this._showLeadGenerationError();
            this._hideOverlay();
        }
        else {
            var currentProdId = this._flowEntities[this._currentEntityId].currentProdId;
            this._eventManager.publish("bss-connector-desired-data-".concat(currentProdId, "-").concat(entityInstanceId), PUBLISHER_NAME, {
                desiredData: desiredData,
            });
        }
        def.resolve(desiredData);
    };
    /**
     * @desc handle general simulator request callback from server, eg
     * - as Callback on BE response after call for financial 'desired' data needed for Save action on Italy
     * @param def {Promise}
     * @param errorCallback {Function}
     * @param successCallback {Function}
     * @param error {{}}
     * @param res {{}}
     */
    BSSControllerToolbox.prototype._makeDataRequestCallback = function (def, errorCallback, successCallback, error, res) {
        var desiredData = this.parseRequest(res);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        if (error || !desiredData) {
            if (errorCallback) {
                errorCallback();
            }
            else {
                this._showLeadGenerationError();
            }
        }
        else {
            var currentProdId = this._flowEntities[this._currentEntityId].currentProdId;
            this._eventManager.publish("bss-connector-received-data-".concat(currentProdId, "-").concat(entityInstanceId), PUBLISHER_NAME, {
                desiredData: desiredData,
            });
            if (successCallback)
                successCallback();
        }
        this._hideOverlay();
        def.resolve(desiredData);
    };
    /**
     * Show error popup on lead generation error response
     * @private
     */
    BSSControllerToolbox.prototype._showLeadGenerationError = function () {
        var errObj = {
            entityInstanceId: this.getCurrentEntityInstanceId(),
            errorCode: 'LEAD_GENERATION_ERROR',
        };
        var _a = this._flowEntities[this._currentEntityId].configuration.layout.texts
            .general.texts, _b = _a.error_lead_generation_title, revertStateTitle = _b === void 0 ? 'Something went wrong during lead generation call' : _b, _c = _a.error_lead_generation_msg, revertStateMsg = _c === void 0 ? 'Please, try again later' : _c;
        this._showErrorPopup({
            revertStateTitle: revertStateTitle,
            revertStateMsg: revertStateMsg,
        }, errObj);
    };
    /**
     * @desc send request to DealerPosInterface
     * @param url
     * @param data
     * @param interval
     * @param endtime
     * @param offerid
     * @param deffObj
     * @return {Object} promise resolved on proposalStatus other than submitted
     * @private
     */
    BSSControllerToolbox.prototype._sendRequestToDealerPosInterface = function (url, data, interval, endtime, offerid, deffObj) {
        var _this = this;
        if (deffObj === void 0) { deffObj = null; }
        logger.info('ControllerToolbox => function: _sendRequestToDealerPosInterface | Params: ', url, data, interval, endtime, offerid);
        this._eventManager.unsubscribeByOwner('ControllerToolboxTabClick');
        this._eventManager.subscribe('bss-step-navigation-tab-click-while-submit', this._onTabChangeWhileSentRequest.bind(this), 'ControllerToolboxTabClick');
        var currentDate = new Date();
        var deff = deffObj || new toolbox.$.Deferred();
        var optionsToSend;
        var entityInstanceId = this.getCurrentEntityInstanceId();
        if (currentDate.getTime() < endtime.getTime()) {
            this._requestTimeout = setTimeout(function () {
                if (!_this._dealerPosInterfaceRequestCanceled) {
                    optionsToSend = {
                        callback: function (error, callbackData) {
                            if (_this._checkRequestErrorAndData(error, callbackData, '_sendRequestToDealerPosInterface', false, offerid)) {
                                if (callbackData.proposalStatus === 'submitted') {
                                    _this._sendRequestToDealerPosInterface(url, data, interval, endtime, offerid, deff);
                                }
                                else {
                                    Object.assign(data[offerid], {
                                        proposalStatus: callbackData.proposalStatus,
                                    });
                                    _this._eventManager.publish('bss-step-navigation-request-succeeded', PUBLISHER_NAME, {});
                                    _this._eventManager.publish('bss-step-navigation-request-financing-event', PUBLISHER_NAME, {
                                        proposalStatus: callbackData.proposalStatus,
                                        internalProposalNumber: data[offerid].internalProposalNumber,
                                    }, true);
                                    deff.resolve();
                                }
                            }
                        },
                        headers: (function (data) {
                            var headers = {};
                            if (typeof data[offerid].aDocumentId === 'string' &&
                                data[offerid].aDocumentId !== '')
                                headers.aDocumentId = data[offerid].aDocumentId;
                            if (typeof data[offerid].rDocumentId === 'string' &&
                                data[offerid].rDocumentId !== '')
                                headers.rDocumentId = data[offerid].rDocumentId;
                            if (typeof data[offerid].dDocumentId === 'string' &&
                                data[offerid].dDocumentId !== '')
                                headers.dDocumentId = data[offerid].dDocumentId;
                            if (data[offerid].offline) {
                                headers.offline = data[offerid].offline;
                            }
                            return headers;
                        })(data),
                    };
                    _this._BSSBackendConnector._makeRequest('GET', url, optionsToSend, entityInstanceId);
                }
                else {
                    deff.reject();
                }
            }, deffObj ? interval : 0);
        }
        else {
            var errObj = {
                entityInstanceId: entityInstanceId,
                errorCode: 'OA_TIMEOUT_ERROR',
            };
            this._errorHandler(null, errObj);
        }
        return deff.promise();
    };
    /**
     * @desc handler for bss-step-navigation-tab-click-after-submit
     * @param {String} publisherName - publisher name
     * @param {Object} params - params send by publisher
     * @private
     */
    BSSControllerToolbox.prototype._onTabChangeAfterSentRequest = function (publishername, params) {
        logger.info('ControllerToolbox => function: _onTabChangeAfterSentRequest | Params: ', publishername, params);
        if (parseInt(params.activeTabId) === parseInt(params.tabLength) - 2) {
            this._dealerPosInterfaceRequestCanceled = false;
            this._stopRequestsAfterNavTabClick = false;
        }
    };
    /**
     * @desc handler for bss-step-navigation-tab-click-while-submit
     * @param {String} publisherName - publisher name
     * @param {Object} params - params send by publisher
     * @emits {bss-hide-entity-overlay-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSControllerToolbox.prototype._onTabChangeWhileSentRequest = function (publishername, params) {
        logger.info('ControllerToolbox => function: _onTabChangeWhileSentRequest | Params: ', publishername, params);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        this._dealerPosInterfaceRequestCanceled = true;
        this._stopRequestsAfterNavTabClick = true;
        clearTimeout(this._requestTimeout);
        this._eventManager.unsubscribeByOwner('ControllerToolboxTabClick');
        this._eventManager.subscribe('bss-step-navigation-tab-click-after-submit', this._onTabChangeAfterSentRequest.bind(this), 'ControllerToolboxTabClick');
        this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, { additionalRequest: true });
    };
    /**
     * @desc callback on entity created
     * @param {Object} data
     * @emits {bss-flow-created-$FLOW-ID} public event
     * @emits {bss-flow-created-$FLOW-ID-entity-$ENTITY-ID-created} public event
     * @emits {bss-flow-created-$FLOW-ID-entity-$ENTITY-ORDER-created} public event
     * @emits {bss-fonts-ready-$ENTITY-INSTANCE-ID} public event
     * @emits {bss-additional-config-apply} public event
     * @listens {bss-params-changed-$ENTITY-INSTANCE-ID}
     * @listens {bss-data-changed-$ENTITY-INSTANCE-ID}
     * @listens {bss-component-critical-error-$ENTITY-INSTANCE-ID}
     * @listens {bss-entity-prod-change-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSControllerToolbox.prototype._onEntityCreated = function (data) {
        var _a, _b, _c, _d, _e;
        logger.info('ControllerToolbox => function: _onEntityCreated | Params: ', data);
        var entityId = this._standalone ? 1 : data.entityId;
        var entityOrder = this._standalone ? 1 : this._getEntityOrder(entityId);
        var entityInstanceId;
        var font = this._flowParams.brand === 'toyota'
            ? new FontFaceObserver('Toyota Type Regular')
            : new FontFaceObserver('NobelWGL-Regular');
        var self = this;
        if (!this._standalone)
            this._setActiveEntity(entityId);
        entityInstanceId = this._standalone ? 1 : this.getCurrentEntityInstanceId();
        if (!this._standalone && this._isSimulator(entityId)) {
            this._entityCounter++;
        }
        // show entity only when is not the one from dependencies
        if (!this._standalone && entityId === this._entityToBeShown) {
            this._showEntity(entityId);
            this._entityToBeShown = null;
        }
        else if (!this._standalone &&
            this._flowEntities[entityId].type === 'onlineApproval') {
            // throw entity-is-shown event to recalculate OA step navigation positioning
            self._eventManager.publish('bss-entity-is-shown-' + entityInstanceId, PUBLISHER_NAME, {});
        }
        if (!this._standalone)
            if (this._flowEntities[entityId].type === 'simulator') {
                // set current product id
                this._flowEntities[entityId].currentProdId =
                    this.entityBuilder.entities.get(entityId).entityActiveProductId;
            }
            else if (this.entityBuilder.entities.size > 1) {
                this._flowEntities[entityId].currentProdId =
                    this.entityBuilder.entities.get(this._prevEntityId).entityActiveProductId;
            }
            else if (!this._currentEntity._entityActiveProductId) {
                this._currentEntity._entityActiveProductId =
                    this._flowEntities[entityId].currentProdId;
            }
        this._eventManager.publish('bss-flow-' + this._flowId + '-entity-' + entityId + '-created', PUBLISHER_NAME, {}, true);
        this._eventManager.publish('bss-flow-' + this._flowId + '-entity-' + entityOrder + '-created', PUBLISHER_NAME, {}, true);
        this._eventManager.publish('bss-entity-created-' + this._flowId, PUBLISHER_NAME, {}, true);
        this._addScrollClass();
        this._addEntityLocationClass();
        this._eventManager.publish('bss-additional-config-apply', PUBLISHER_NAME, {}, true);
        this._eventManager.subscribe('bss-params-changed-' + entityInstanceId, this._onParamsChange.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe('bss-data-changed-' + entityInstanceId, this._onUserChange.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe('bss-button-lookup-event', this._onLookUp.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe("bss-component-critical-error-".concat(entityInstanceId), this._componentErrorHandler.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe("bss-entity-prod-change-".concat(entityInstanceId), this._onProductChange.bind(this), 'ControllerToolbox');
        this._eventManager.subscribe("bss-get-lead-generation-data-".concat(this._flowId), this._getLeadGenerationData, 'ControllerToolbox');
        this._eventManager.subscribe("bss-connector-recived-desired-data-".concat(entityInstanceId), this._makeDesiredDataRequest, 'ControllerToolbox');
        this._eventManager.subscribe("bss-component-minor-error-".concat(entityInstanceId), this._showMinorErrorPopup, 'ControllerToolbox');
        this._eventManager.publish("bss-data-change-ready-".concat(entityInstanceId), PUBLISHER_NAME, {});
        this._publishTaggingEvent(entityId, 'simulatorHasFullyLoaded');
        if (this.elementType === 'compareFinance' &&
            this.isCompareFinance &&
            this._insideWidgetQuoteId) {
            if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.location) === 'body')
                this._eventManager.publish('bss-run-simulator-in-widget', PUBLISHER_NAME, {}, true);
            else
                this._eventManager.publish('bss-run-simulator-in-widget-aph', PUBLISHER_NAME, {}, true);
        }
        var entityType = (_b = toolbox._.find(this._flowEntities, function (entity) { return entity.order === entityOrder; })) === null || _b === void 0 ? void 0 : _b.type;
        if (entityType !== 'productComparison') {
            if (!(this._isWidgetInWidget &&
                this.elementType === 'simulator' &&
                !this._finance)) {
                (_d = (_c = toolbox.dxpTagging) === null || _c === void 0 ? void 0 : _c[entityId]) === null || _d === void 0 ? void 0 : _d.init(__assign(__assign({}, toolbox.resultDataFlat[this._flowEntities[entityId].currentProdId]), { integrationMode: ((_e = this._options) === null || _e === void 0 ? void 0 : _e.integrationMode) || null }));
            }
        }
        font
            .load()
            .then(function (el) {
            logger.info('ControllerToolbox => function: _onEntityCreated | then | Params: ', el);
            self._eventManager.publish('bss-fonts-ready-' + entityInstanceId, PUBLISHER_NAME, {}, true);
        })
            .catch(function (el) {
            logger.warn('ControllerToolbox => function: _onEntityCreated | catch | Params: ', el);
        });
    };
    /**
     * @desc function for lookup button click event handling
     * @param {String} publisher
     * @param {Object} dataObject
     * @private
     */
    BSSControllerToolbox.prototype._onLookUp = function (publisher, dataObject) {
        var _this = this;
        logger.info('ControllerToolbox => function: _onLookUp | Params: ', publisher, dataObject);
        if (dataObject.inputDataMap && dataObject.inputDataMap[0].dataValueName) {
            var postcode = toolbox.$('[data-value="' + dataObject.inputDataMap[0].dataValueName + '.value"]');
            if (!postcode.valid()) {
                return;
            }
        }
        var lookupSelect = toolbox.$('[data-dropname="' + dataObject.cacheDataDropname + '"]');
        var url = dataObject.url;
        var entityInstanceId = this.getCurrentEntityInstanceId();
        var optionsToSend = {
            callback: function (error, callbackData) {
                if (_this._checkRequestErrorAndData(error, callbackData, '_onLookUp', false)) {
                    _this._eventManager.publish('bss-connector-bind-lookup-select-' + entityInstanceId, 'address-bind-lookup-select', {
                        callbackData: callbackData,
                        dataObject: dataObject,
                    });
                    if (callbackData.length >= 2) {
                        _this._eventManager.publish('bss-connector-lookup-select-change-' + entityInstanceId, 'address-change-lookup-select', {
                            lookupSelect: lookupSelect,
                            lookupSelectVal: 3,
                        });
                        lookupSelect
                            .closest(RULE_INTERACT_CONTAINER)
                            .show()
                            .removeClass('hidden rule-interact-container-hidden');
                    }
                    _this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, 'address-lookup', { additionalRequest: true });
                    _this._eventManager.publish('bss-step-navigation-on-form-change-' + entityInstanceId, PUBLISHER_STEP_NAVIGATION, { valid: false });
                    _this._eventManager.publish('bss-step-navigation-dropdownEmployment-0-change', PUBLISHER_STEP_NAVIGATION, { postcodeVal: true });
                    _this._eventManager.publish('bss-step-navigation-dropdownEmployment-1-change', PUBLISHER_STEP_NAVIGATION, { postcodeVal: true });
                }
            },
            params: {},
        };
        if (dataObject.manuallyButton) {
            this._prepareActionsWhenManuallyButtonIsClicked(dataObject, lookupSelect, entityInstanceId);
            return;
        }
        this._eventManager.publish(SHOW_ENTITY_EVENT + entityInstanceId, 'address-lookup', { additionalRequest: true });
        for (var _i = 0, _a = dataObject.inputDataMap; _i < _a.length; _i++) {
            var input = _a[_i];
            var inputValue = toolbox
                .$('input[data-value="' + input.dataValueName + '.value"]')
                .val();
            if (inputValue !== '') {
                optionsToSend.params[input.queryName] = inputValue;
            }
        }
        if (typeof url !== 'undefined') {
            url = url + '/' + optionsToSend.params.postcode;
            this._BSSBackendConnector._makeRequest('GET', url, optionsToSend, entityInstanceId);
        }
    };
    BSSControllerToolbox.prototype._prepareActionsWhenManuallyButtonIsClicked = function (dataObject, lookupSelect, entityInstanceId) {
        var parentId = dataObject.parentId || null;
        var $interactContainer = parentId
            ? lookupSelect.closest(parentId).find(RULE_INTERACT_CONTAINER)
            : lookupSelect
                .closest(RULE_INTERACT_CONTAINER)
                .siblings(RULE_INTERACT_CONTAINER);
        if (lookupSelect.val() > 4) {
            $interactContainer.find('input').prop('disabled', false);
        }
        else {
            var manuallyInputsName = dataObject === null || dataObject === void 0 ? void 0 : dataObject.manuallyInputsName;
            if (manuallyInputsName === null || manuallyInputsName === void 0 ? void 0 : manuallyInputsName.length) {
                manuallyInputsName.forEach(function (input) {
                    toolbox.$("[name=".concat(input, "]")).removeAttr('disabled');
                });
            }
            $interactContainer.removeClass('hidden rule-interact-container-hidden');
            this._eventManager.publish('bss-connector-lookup-select-change-' + entityInstanceId, 'address-change-lookup-select', {
                lookupSelect: lookupSelect,
                lookupSelectVal: 4,
            });
            lookupSelect.closest(RULE_INTERACT_CONTAINER).hide();
            this._eventManager.publish('bss-step-navigation-on-form-change-' + entityInstanceId, PUBLISHER_STEP_NAVIGATION, { valid: true });
            this._eventManager.publish('bss-step-navigation-dropdownEmployment-0-change', PUBLISHER_STEP_NAVIGATION, { postcodeVal: true });
            this._eventManager.publish('bss-step-navigation-dropdownEmployment-1-change', PUBLISHER_STEP_NAVIGATION, { postcodeVal: true });
        }
    };
    /**
     * @desc gets text for chosen language
     * @param {String} publisherName - publisher name
     * @param {Object} options - object provided with event
     * @private
     */
    BSSControllerToolbox.prototype._getTexts = function (publisherName, options) {
        logger.info('ControllerToolbox => function: _getTexts | Params: ', publisherName, options);
        var textsUrl = this._flowEntities[this._currentEntityId].textsUrlBase
            .replace(ENTITY_ID, this._currentEntityId)
            .replace('{lang}', options.lang);
        var entityInstanceId = this.getCurrentEntityInstanceId();
        this._BSSBackendConnector.getTexts(textsUrl, this._textReceived.bind(this), entityInstanceId);
    };
    /**
     * @desc gets text callback
     * @param {Object} error
     * @param {Object} data
     * @emits {bss-text-received-$ENTITY-INSTANCE-ID} when there is no error and data nodes exist
     * @private
     */
    BSSControllerToolbox.prototype._textReceived = function (error, data) {
        logger.info('ControllerToolbox => function: _textReceived | Params: ', error, data);
        // if there is no error and all data nodes exist
        if (this._checkRequestErrorAndData(error, data, 'textReceived')) {
            var entityInstanceId = this.getCurrentEntityInstanceId();
            this._eventManager.publish('bss-text-received-' + entityInstanceId, PUBLISHER_NAME, data);
        }
    };
    /**
     * @desc return unbalanced error message - first scenario
     * @return {string} - return unbalanced error message - first scenario
     * @private
     */
    BSSControllerToolbox.prototype._getUnbalancedErrorMessage = function () {
        var currentProdId = this._flowEntities[this._currentEntityId].currentProdId;
        //a name ending with 'one' was used because there are two unbalanced error messages for the popup.
        // the second message value was used in uidescription
        return this._flowEntities[this._currentEntityId].configuration.layout.texts[currentProdId].unbalanced_message_one;
    };
    /**
     * @desc check error and data received after data request
     * @param {Object} error - error object
     * @param {Object} data - flow configuration object
     * @param {string} funName - the caller function name
     * @param {boolean} [checkInnerNodes=true] - if true check weather inner nodes exists (false on initialization for calculateOffer function)
     * @param {string} [offerId=''] - current offer id
     * @return {Boolean} - return true when there is no error and data nodes exist
     * @private
     */
    BSSControllerToolbox.prototype._checkRequestErrorAndData = function (error, data, funName, checkInnerNodes, offerId) {
        var _a, _b;
        if (checkInnerNodes === void 0) { checkInnerNodes = true; }
        if (offerId === void 0) { offerId = ''; }
        logger.info('ControllerToolbox => function: _checkRequestErrorAndData | Params: ', error, data, funName, checkInnerNodes, offerId);
        var errObj = {
            entityInstanceId: this.getCurrentEntityInstanceId(),
            errorMsg: 'ControllerToolbox ' + funName + ' callback error: ',
            offerId: offerId,
            errorCode: null,
        };
        if (error !== null) {
            if (error.code === 'CALCULATION_ERROR') {
                errObj.errorMsg = error.msg;
                errObj.errorCode = error.code;
                // Error with component validation, eg fi laske hinta
            }
            else if (error.status === 400) {
                switch (error.code) {
                    case 'VALIDATION_ERROR':
                    case 'SPECIAL_CIRCUMSTANCES_FOR_GB_PCH_PRODUCT_ERROR':
                        errObj.errorMsg = error.msg;
                        errObj.errorCode = error.code;
                        errObj.status = error.status;
                        break;
                    case 'UNBALANCED_PLAN_ERROR':
                        errObj.errorMsg = this._getUnbalancedErrorMessage();
                        errObj.errorCode = error.code;
                        errObj.status = error.status;
                        break;
                }
            }
            else {
                errObj.errorMsg +=
                    error.status + ' - ' + error.code + ' - ' + error.msg + '.';
                errObj.errorCode = error.code;
            }
            this._errorHandler(null, errObj, false);
            return false;
        }
        else if (data === null || typeof data === 'undefined' || data === {}) {
            errObj.errorMsg += 'Configuration data is empty.';
            this._errorHandler(null, errObj, false);
            return false;
        }
        else if (data[offerId] &&
            typeof data[offerId].error_code !== 'undefined') {
            errObj.errorMsg += 'Configuration data are no good.';
            this._errorHandler(null, errObj, false);
            return false;
        }
        else if (((_a = data[offerId]) === null || _a === void 0 ? void 0 : _a.calculationError) !== undefined &&
            ((_b = data[offerId]) === null || _b === void 0 ? void 0 : _b.financialPlan) === '[]') {
            /* when user enters value which can not be balanced for monhlty rates table the Backend returns empty array in string format
            then we need get error message from layout.texts*/
            errObj.errorMsg = this._getUnbalancedErrorMessage();
            this._errorHandler(null, errObj, false);
            return false;
        }
        // check if all mandatory config nodes are defined
        else if (checkInnerNodes) {
            var self_3 = this;
            var dataNodes_1 = {};
            var allDataNodesExists_1 = true;
            if (funName === 'setFlowConfiguration') {
                if (data.entities) {
                    dataNodes_1 = {
                        base: ['flowId', 'initialEntityId'],
                        entities: {},
                    };
                    toolbox._.forEach(data.entities, function (value, key) {
                        dataNodes_1.entities[key] = {
                            base: ['commonURLs', 'container'],
                            commonURLs: ['entitySimulatorURL'],
                        };
                        if (value.type !== 'productComparison') {
                            dataNodes_1.entities[key].commonURLs.push('entityDataURL');
                        }
                        if (value.type === 'onlineApproval') {
                            dataNodes_1.entities[key].commonURLs.push('entityApproveURL');
                        }
                    });
                }
                else {
                    dataNodes_1 = {
                        base: ['flowId', 'initialEntityId', 'commonURLs'],
                        commonURLs: ['entitySimulatorURL', 'entityDataURL'],
                    };
                }
            }
            else if (funName === 'getCalculatedOffer') {
                dataNodes_1 = {
                    base: ['resultData', 'layout'],
                    layout: ['components', 'texts'],
                };
                if (this.elementType !== 'productComparison') {
                    dataNodes_1.layout.push('formatters');
                }
            }
            // else if (checkInnerNodes && (funName === 'textReceived')) {} // there is no special nodes to check
            // check if all nodes from dataNodes exists
            toolbox._.forEach(dataNodes_1, function (nodesArray, nodeParent) {
                if (!allDataNodesExists_1) {
                    return false;
                }
                if (nodeParent === 'base') {
                    toolbox._.forEach(nodesArray, function (nodeName) {
                        if (!self_3._hasConfigNode(data[nodeName], nodeName)) {
                            allDataNodesExists_1 = false;
                            return false;
                        }
                    });
                }
                else if (nodeParent === 'entities') {
                    toolbox._.forEach(nodesArray, function (values, key) {
                        // check all entities in response.
                        toolbox._.forEach(nodesArray[key], function (nodesArray, nodeParent) {
                            // value
                            if (nodeParent === 'base') {
                                toolbox._.forEach(nodesArray, function (nodeName) {
                                    if (!self_3._hasConfigNode(data.entities[key][nodeName], nodeName)) {
                                        allDataNodesExists_1 = false;
                                        return false;
                                    }
                                });
                            }
                            else {
                                toolbox._.forEach(nodesArray, function (nodeName) {
                                    // value
                                    if (!self_3._hasConfigNode(data.entities[key][nodeParent][nodeName], nodeName)) {
                                        allDataNodesExists_1 = false;
                                        return false;
                                    }
                                });
                            }
                        });
                    });
                }
                else {
                    toolbox._.forEach(nodesArray, function (nodeName) {
                        // value
                        if (!self_3._hasConfigNode(data[nodeParent][nodeName], nodeName)) {
                            allDataNodesExists_1 = false;
                            return false;
                        }
                    });
                }
            });
            // if some nodes don't exist or are empty, show error
            if (!allDataNodesExists_1) {
                errObj.errorMsg =
                    'ControllerToolbox function:' +
                        funName +
                        ' request verification fail. Not all mandatory request field are in response';
                this._errorHandler(null, errObj, false);
                return false;
            }
        }
        // there is no error and all mandatory nodes exists
        // merge the latest data and validation error list if it's occurred
        if (data.error_code === 'VALIDATOR_ERROR') {
            var currentProdId = this._flowEntities[this._currentEntityId].currentProdId;
            if (Object.hasOwn(data, 'resultData')) {
                data.resultData[currentProdId]['errors'] = data.errors;
            }
            else if (Object.hasOwn(data, currentProdId)) {
                data[currentProdId]['errors'] = data.errors;
            }
            delete data.errors;
            // merge the latest data and balancing error if it's occurred
        }
        return true;
    };
    BSSControllerToolbox.prototype._checkNode = function (arrayElement, nodeName) {
        if (!self._hasConfigNode(arrayElement, nodeName)) {
            return false;
        }
    };
    /**
     * @desc error handling - show error massage or revert entity state to previous state
     * @param {string} publisherName
     * @param {{}} errorObject - error object with entityInstanceId and errorMsg
     * @param {boolean} [isComponentError=false] - set to true when component error occurs during an update
     * @emits {bss-hide-entity-overlay-$ENTITY-INSTANCE-ID} when entity state is reverted
     * @emits {bss-received-request-$ENTITY-INSTANCE-ID} when received request
     * @private
     */
    BSSControllerToolbox.prototype._errorHandler = function (publisherName, errorObject, isComponentError) {
        if (isComponentError === void 0) { isComponentError = false; }
        logger.info('ControllerToolbox => function: _errorHandler | Error: Critical Error | Params: ', publisherName, errorObject, isComponentError);
        var configGeneralTexts;
        var generalRevertStateMsg;
        var entityInstanceId = this.getCurrentEntityInstanceId();
        try {
            configGeneralTexts = Object.assign({}, this._flowEntities[this._currentEntityId].configuration.layout.texts
                .general);
            generalRevertStateMsg = configGeneralTexts.revertStateMsg;
            // if an error occurs CALCULATION_ERROR and display the specified message
            switch (errorObject.errorCode) {
                case 'CALCULATION_ERROR':
                    configGeneralTexts.revertStateMsg = errorObject.errorMsg;
                    break;
                case 'SPECIAL_CIRCUMSTANCES_FOR_GB_PCH_PRODUCT_ERROR':
                    configGeneralTexts.revertStateTitle = 'VALUES ERROR';
                    configGeneralTexts.revertStateMsg = errorObject.errorMsg;
                    break;
                case 'VALIDATION_ERROR':
                    if (errorObject.status === 400) {
                        configGeneralTexts.revertStateMsg = errorObject.errorMsg;
                    }
                    this._eventManager.publish('bss-validation-error-' + errorObject.entityInstanceId, PUBLISHER_NAME, {});
                    break;
                case 'UNBALANCED_PLAN_ERROR':
                    configGeneralTexts.revertStateTitle =
                        configGeneralTexts.plan_unbalanced_title;
                    configGeneralTexts.revertStateMsg = errorObject.errorMsg;
                    break;
                case 'OA_TIMEOUT_ERROR':
                    configGeneralTexts.revertStateTitle =
                        configGeneralTexts.oaTimeoutErrorTitle;
                    configGeneralTexts.revertStateMsg =
                        configGeneralTexts.oaTimeoutErrorMessage;
                    break;
                case 'DEFAULT_ERROR':
                    configGeneralTexts.revertStateTitle =
                        configGeneralTexts.errorInfoTitle;
                    configGeneralTexts.revertStateMsg = configGeneralTexts.errorInfoMsg;
                    break;
                case 'ADDRESS_NOT_FOUND':
                    configGeneralTexts.revertStateTitle =
                        configGeneralTexts.address_lookup_too_many_entries_error_title;
                    configGeneralTexts.revertStateMsg =
                        configGeneralTexts.address_lookup_too_many_entries_error;
                    break;
                case 'INTERNAL_SERVER_ERROR':
                    if (this._isPopupPC) {
                        configGeneralTexts.revertStateTitle =
                            configGeneralTexts.popupErrorInfoTitle;
                        configGeneralTexts.revertStateMsg =
                            configGeneralTexts.popupErrorInfoMsg;
                    }
                    break;
            }
        }
        catch (err) {
            configGeneralTexts = {
                errorInfoTitle: 'Content failed to load',
                errorInfoMsg: 'We experienced a technical issue. Our team is working on getting this fixed as soon as we can. Please try again later.',
                revertStateTitle: 'VALUES ERROR',
                revertStateMsg: 'Values you selected are no good because of reasons. We reverted them back.',
            };
        }
        this._stopPreLoader();
        // if an error occurs before entity init, show error template
        if (typeof errorObject.entityInstanceId === 'undefined') {
            this._showErrorTemplate(configGeneralTexts);
        }
        // else revert its state to previous one (entity is already created)
        else {
            this._eventManager.publish('bss-entity-error-' + errorObject.entityInstanceId, PUBLISHER_NAME, {});
            this._revertEntityOffer(configGeneralTexts, errorObject, isComponentError);
            this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + entityInstanceId, PUBLISHER_NAME, Object.assign({}, this.getCustomOffer(), {
                entityRevertedOnError: true,
            }));
        }
        configGeneralTexts.revertStateMsg = generalRevertStateMsg;
        this._eventManager.publish('bss-received-request-' + entityInstanceId, PUBLISHER_NAME, {});
    };
    /**
     * Stop preloader
     * @private
     */
    BSSControllerToolbox.prototype._stopPreLoader = function () {
        logger.info('ControllerToolbox => function: _stopPreLoader | Params: ');
        if (window.PreLoader && window.PreLoader.running) {
            // On error remove PreLoader.
            window.PreLoader.stop();
        }
    };
    /**
     * @desc Add location class to enable styling of in-page simulator (standalone version)
     * without interfering with elements using older injection mechanism (popup version).
     * Class will be added only when location exists in initial configuration.
     * Class should be added on entity container in each case:
     * - when initial error occurs and error template is rendered
     * - when entity is rendered with success
     * @param {jQuery | HTMLElement} [$entityContainer = this._entityContainer] reference to the entity container element
     * @private
     */
    BSSControllerToolbox.prototype._addEntityLocationClass = function ($entityContainer) {
        if ($entityContainer === void 0) { $entityContainer = this._entityContainer; }
        var location = toolbox.location;
        if (location) {
            $entityContainer.addClass("bss-entity-container--location-".concat(location));
        }
    };
    /**
     * @desc Add error class to enable styling for 'initial error' case.
     * Class will be added on entity container when initial error occurs and error template is rendered,
     * it does not refer to specific market in this case.
     * Initially used to style in-page simulator without impact on existing simulators.
     * @param {jQuery | HTMLElement} $entityContainer reference to the entity container element
     * @private
     */
    BSSControllerToolbox.prototype._addEntityErrorClass = function ($entityContainer) {
        $entityContainer.addClass("bss-entity-container--initial-error");
    };
    /**
     * Ff an error occurs before entity init, show error template
     * @params {{}} errorTemplateConfig
     * @private
     */
    BSSControllerToolbox.prototype._showErrorTemplate = function (errorTemplateConfig) {
        logger.info('ControllerToolbox => function: _showErrorTemplate | Params: ', errorTemplateConfig);
        // Get template filled by data
        var $simulatorErrorTemplate = toolbox.$(simulatorTemplates.errorTemplate(errorTemplateConfig));
        // Render simulator error template
        var $currentEntityContainer = this._getCurrentEntityContainer();
        var entityHiddenClass = 'bss-entity--is-hidden';
        this._addEntityLocationClass($currentEntityContainer);
        this._addEntityErrorClass($currentEntityContainer);
        $currentEntityContainer
            .html($simulatorErrorTemplate)
            .removeClass(entityHiddenClass)
            .show();
        this._theme && $simulatorErrorTemplate.addClass("bss-theme-".concat(this._theme));
        // Callbacks
        this._disableOABtn();
        this._simulatorErrorTemplateLoaded = true;
        this._eventManager.publish(ENTITY_OVERLAY_SELECTOR + this.getCurrentEntityInstanceId(), PUBLISHER_NAME, {});
    };
    /**
     * Return current entity container jQuery reference
     * @returns {Window.jQuery|HTMLElement|*}
     * @private
     */
    BSSControllerToolbox.prototype._getCurrentEntityContainer = function () {
        logger.info('ControllerToolbox => function: _getCurrentEntityContainer');
        if (this._currentEntityId &&
            this._flowEntities &&
            this._flowEntities[this._currentEntityId]) {
            return (this._flowEntities[this._currentEntityId].entityContainer &&
                this._entityContainer);
        }
        return this._entityContainer;
    };
    /**
     * Disable OA button on simulator error
     * @private
     */
    BSSControllerToolbox.prototype._disableOABtn = function () {
        logger.info('ControllerToolbox => function: _disableOABtn');
        var OABtnSelector = ONLINE_APPROVAL_BUTTON_CLASS;
        var $OABtn = toolbox.$(OABtnSelector);
        if ($OABtn) {
            $OABtn.prop('disabled', false);
        }
    };
    /**
     * @desc error handling - revert offer to previous state if error occurs after entity initialization
     * @param {Object} configGeneralTexts - general texts object
     * @param {Object} errorObject - error object
     * @param {Boolean} isComponentError - set to true when component error occurs during an update
     * @emits {bss-entity-revert-state-$ENTITY-INSTANCE-ID} - published ony when isComponentError is true
     * @emits {bss-data-received-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSControllerToolbox.prototype._revertEntityOffer = function (configGeneralTexts, errorObject, isComponentError) {
        logger.info('ControllerToolbox => function: _revertEntityOffer | Params: ', configGeneralTexts, errorObject, isComponentError);
        var prevOffer = this._flowEntities[this._currentEntityId].customOfferPrevious;
        var defOffer = this.getDefaultOffer();
        var offer = toolbox.$.isEmptyObject(prevOffer) ? defOffer : prevOffer;
        var singleProdResultData = JSON.parse(JSON.stringify(offer));
        // set previous offer as current one
        this._flowEntities[this._currentEntityId].customOffer = offer;
        if (isComponentError) {
            this._eventManager.publish('bss-entity-revert-state-' + errorObject.entityInstanceId, PUBLISHER_NAME, {});
        }
        else {
            this._lastUpdateTimestamp = null;
        }
        toolbox._.each(singleProdResultData.resultData, function (val, key) {
            if (key !== errorObject.offerId) {
                delete singleProdResultData.resultData[key];
            }
        });
        singleProdResultData.updateTimestamp = this._lastUpdateTimestamp;
        // some error from Entity _onDataReceived doesn't return errorObject.offerId
        if (Object.keys(singleProdResultData.resultData).length === 0) {
            singleProdResultData = JSON.parse(JSON.stringify(this.getCustomOffer()));
        }
        if (errorObject.errorCode !== 'ADDRESS_NOT_FOUND') {
            if (errorObject.errorMsg) {
                var currentProdId = this._flowEntities[this._currentEntityId].currentProdId;
                // Update errorMsg to be used in the components after data update
                singleProdResultData.resultData[currentProdId].revertErrorMsg =
                    errorObject.errorMsg;
            }
            this._eventManager.publish('bss-data-received-' + errorObject.entityInstanceId, PUBLISHER_NAME, singleProdResultData);
        }
        if (!this._noErrorPopup) {
            this._showErrorPopup(configGeneralTexts, errorObject);
        }
    };
    /**
     * Show general error popup
     * @param {{revertStateTitle: string, revertStateMsg: string}} revertTemplateConfig - config containing data for entity-revert-info-component
     * @param {Object} errorObject - error object
     * @private
     */
    BSSControllerToolbox.prototype._showErrorPopup = function (revertTemplateConfig, errorObject) {
        logger.info('ControllerToolbox => function: _showErrorPopup | Params:', revertTemplateConfig, errorObject);
        var isNoAmd = !this._entityContainer.hasClass('bss-amd');
        var entityHeight = toolbox
            .$(this._currentEntity._entitySelector)
            .outerHeight();
        // show snackbar with information about the error and state revert - from config.texts.general
        var $simulatorRevertTemplate = toolbox.$(simulatorTemplates.revertTemplate(revertTemplateConfig));
        var revertTemplateHeight = $simulatorRevertTemplate.outerHeight();
        var $currentEntityContainer = this._flowEntities[this._currentEntityId].entityContainer;
        var $overlayEl = $currentEntityContainer.find('.bss-popup_overlay');
        $overlayEl.addClass('is-active');
        $currentEntityContainer.append($simulatorRevertTemplate);
        var $closeButton = $simulatorRevertTemplate.find('.bss-entity-revert-state-info-close-icon');
        // Remove error popup on close button click
        var closeErrorPopup = function () {
            $overlayEl.removeClass('is-active');
            $simulatorRevertTemplate.fadeOut(400, function () {
                $currentEntityContainer.find('.bss-entity-revert-state-info').remove();
            });
            $overlayEl.off('click', closeErrorPopup);
        };
        $closeButton.on('click', closeErrorPopup);
        $overlayEl.on('click', closeErrorPopup);
        if (isNoAmd) {
            var componentPositionTop = typeof errorObject.componentId !== 'undefined'
                ? toolbox.$('#' + errorObject.componentId).offset().top
                : 0;
            var entityMiddlePos = entityHeight / 2 - revertTemplateHeight / 2;
            var top_1 = typeof errorObject.componentId !== 'undefined'
                ? componentPositionTop
                : entityMiddlePos;
            $simulatorRevertTemplate.css({ top: top_1 + 'px' });
        }
    };
    BSSControllerToolbox.prototype.destroyOA = function (entityId) {
        logger.info('ControllerToolbox => function: destroyOA | Params: ', entityId);
        this.entityBuilder.destroyEntity(entityId);
        this._dealerPosInterfaceRequestCanceled = true;
        toolbox.$(this._entitySelector + ' #onlineApproval *').remove();
        toolbox
            .$(this._entitySelector + ' #onlineApproval')
            .removeAttr('style')
            .removeClass();
    };
    return BSSControllerToolbox;
}(BaseControllerToolbox));
export { BSSControllerToolbox };
